import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=697c7005&scoped=true&"
import script from "./TagEditor.vue?vue&type=script&lang=js&"
export * from "./TagEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697c7005",
  null
  
)

export default component.exports